import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Modal, Icon, Text, Upload, Button, Textarea } from '@atomic';
import { ReactComponent as PostSvg } from '@assets/icon/icn_post.svg';
import IconCloseUrl from '@assets/icon/icn_close.svg';
import { COLOR_FONT_GRAY } from '@assets/color';
import { CreatePostApi, CHANNEL_ID } from '@api/PostApi';

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  gap: 10px;
`;

const ImgContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
`;

const ModalCreatePost = ({ onClose, ...props }) => {
  const imgRef = useRef(null);
  const newPostFormData = new FormData();
  const [post, setPost] = useState({
    title: '',
    image: '',
    channelId: CHANNEL_ID,
  });

  const handleChangeImg = (file) => {
    setPost({
      ...post,
      image: file,
    });
    const preview = new FileReader();
    preview.readAsDataURL(file);
    preview.onload = () => {
      imgRef && (imgRef.current.src = preview.result);
    };
  };

  const handlePosting = async () => {
    newPostFormData.append('image', post.image);
    newPostFormData.append('title', post.title);
    newPostFormData.append('channelId', post.channelId);

    try {
      await CreatePostApi(newPostFormData);
      handleClose();
    } catch (e) {
      console.log('포스트 생성에 실패했습니다.', e);
    }
  };

  const handleClose = () => {
    onClose && onClose();
  };

  return (
    <Modal style={{ padding: '20px' }} {...props} onClose={onClose}>
      <Icon src={IconCloseUrl} clickable iconSize={20} onClick={handleClose} />
      <ContentWrapper>
        <Text strong textSize={18}>
          New Post
        </Text>
        <Upload droppable accept="img/*" onChange={handleChangeImg}>
          {(file) => (
            <>
              {file ? (
                <Img ref={imgRef} alt="이미지 업로더" />
              ) : (
                <ImgContainer>
                  <PostSvg className="posting-icn" />
                  <Text style={{ color: `${COLOR_FONT_GRAY}` }}>
                    사진을 선택해 주세요
                  </Text>
                </ImgContainer>
              )}
            </>
          )}
        </Upload>
        <Textarea
          noteType
          width="100%"
          height="130px"
          value={post.title}
          onChange={(e) => {
            setPost({
              ...post,
              title: e.target.value,
            });
          }}
        />
        <Button onClick={() => handlePosting()}>Post</Button>
      </ContentWrapper>
    </Modal>
  );
};

ModalCreatePost.propTypes = {
  onClose: PropTypes.func,
  createPost: PropTypes.func,
};

export default ModalCreatePost;
